import React from "react"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/nico/Layout"
import ProgramActivityExample from "../../components/nico/ProgramActivityExample"
import ProgramSchedule from "../../components/nico/ProgramSchedule"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"

const program = () => {
  return (
    <Layout>
      <SEO title={PAGE.title.program} siteTitle="nico" />
      <HeadingL title={PAGE.title.program} target="nico" />
      <ProgramSchedule />
      <ProgramActivityExample />
    </Layout>
  )
}

export default program
